import { render, staticRenderFns } from "./RejectMarketingModal.vue?vue&type=template&id=6418c8c2"
import script from "./RejectMarketingModal.vue?vue&type=script&lang=js"
export * from "./RejectMarketingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports